<div class="container" data-cy="select-channel-window-section">
    <div class="title-wrapper">
        <div class="title-container">
            <div data-cy="select-channel-window-section-name">
                {{ title | translate }}
            </div>
            <div *ngIf="selectedElements.length > 0" class="selected-elements-number">
                <div class="length-container">
                    {{ selectedElements.length }}
                </div>
            </div>
        </div>
        <div style="display: flex; align-items: center; cursor: pointer" (click)="showElements()">
            <div class="show-less-button">
                {{
                    shouldShowElements
                        ? ('channel-search.dialog.button.show-less' | translate)
                        : ('channel-search.dialog.button.show-more' | translate)
                }}
            </div>
            <mat-icon
                svgIcon="arrow-down"
                class="arrow-down"
                [ngStyle]="{
                    transform: shouldShowElements ? 'rotate(180deg)' : '',
                }" />
        </div>
    </div>
    <div class="elements-container" *ngIf="shouldShowElements && elementList.length > 0">
        <div
            *ngFor="let element of elementList"
            class="element-bubble"
            [ngClass]="{
                selected: elementIsSelected(element),
                disabled: shouldDisable,
            }"
            (click)="selectElement(element)"
            data-cy="select-channel-window-section-option">
            <ng-container *ngIf="isCategoryList()">
                {{ element.category }}
            </ng-container>

            <ng-container *ngIf="isTypeList()">
                {{ element }}
            </ng-container>

            <ng-container *ngIf="isGroupList()">
                <div class="group-category">
                    {{ element.channelCategory.category }}
                </div>
                <div>{{ element.displayName }}</div>
            </ng-container>
        </div>
    </div>
    <div *ngIf="elementList.length == 0" class="empty-list">
        <ng-container *ngIf="listBubbleType == 'group'">
            {{ 'bubble-selector.placeholder.group' | translate }}
        </ng-container>
    </div>
</div>
